import React, { useEffect, useState, useRef } from "react"
import "./styles.scss"

import { gsap } from "gsap"

const DigitsRow = ({ data }) => {
  const digitsRowWrapperRef = useRef([])

  useEffect(() => {
    gsap.from(digitsRowWrapperRef.current.childNodes, {
      opacity: 0,
      x: 50,
      stagger: 0.2,
      duration: .6,
      delay: 0.5,
    })
  }, [digitsRowWrapperRef])

  return (
    <div className="digitsRow">
      <div className="wrapper--text">
        <div className="digitsRow__wrapper" ref={digitsRowWrapperRef}>
          {data?.map((item, index) => {
            return (
              <div className="digitsRow__item" key={index}>
                <div className="digitsRow__itemDigit">
                  {item.digit}
                </div>
                <div className="digitsRow__itemDescription">
                  {item.description}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DigitsRow
